import { createFileRoute, redirect } from "@tanstack/react-router";
import { waitingOnYouSearch } from "./waiting-on-you";

/**
 * The step queue's former address (Jira NAV-111, and NAV-84 before it).
 *
 * The steps are a tab of "Waiting on you" now, and this address arrives on it.
 * Every step reminder and clarification notice already in Firestore links here
 * (some to `/end-user/approvals` before that, which forwards here too), with the
 * `?request=` that decides which card opens — so the address has to keep
 * resolving, and it has to arrive at the same card, which is why the params are
 * validated with the destination's own schema and carried across rather than
 * dropped. New notifications are minted against the current address
 * (`send_step_reminders_use_case`, `notify_clarification_use_case`).
 *
 * The tab is named rather than left to the destination's default: this address
 * meant the steps, and a later decision about which tab a bare address opens
 * must not re-point a link that went out in an email.
 */
export const Route = createFileRoute("/end-user/evaluation-steps")({
  validateSearch: waitingOnYouSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/end-user/waiting-on-you",
      search: { ...search, tab: "steps" },
      replace: true,
    });
  },
});
